module.exports = __webpack_public_path__ + "img/logo.b67b9711.png";